
const glossaryTagQA = {
  header: {
    logo: 'header_logo',
    toolTip: {
      sell: 'sell_tooltip',
      help: 'help_tooltip',
      fav: 'fav_tooltip',
      account: 'account_tooltip',
      cart: 'cart_tooltip',
      priceclub: 'club_tooltip',
    },
    search: {
      button: 'search_button',
      input: 'search_input',
    },
  },
  hpv: {
    input: 'search-input',
    cta: 'search-cta',
    suggest: 'suggest',
  },
  lightHeader: {
    lightHeaderContainer: 'lightheader-container',
    logo: 'lightheader-logo-rakuten',
    clubR: 'lightheader-club-R',
    help: 'lightheade-aide',
    account: 'lightheader-mon-compte',
  },
};

export default glossaryTagQA;
